import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import styles from './HomePage.module.scss';
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { setSearchMessages, setTargetMessages } from "../../store/slices/appSlice";
import { searchMessagesInList } from "../../utils/utils";
import { useDebounce } from 'use-debounce';
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
import InputComponent from "../../InputComponent/InputComponent";
const SearchMessages = () => {
    const [text, setText] = useState('');
    // const isOpen = useAppSelector(state => state.app.isSearchMessage)
    const list = useAppSelector(state => state.messages.messages);
    const [debouncedText] = useDebounce(text, 1000);
    const inputRefContainer = useRef(null);
    const inputRef = useRef(null);
    const { t } = useTypedTranslation();
    const dispatch = useAppDispatch();
    const show = () => {
        if (inputRefContainer.current && inputRef.current) {
            inputRef.current.focus();
            inputRefContainer.current.style.width = '100%';
        }
    };
    const hide = () => {
        if (inputRefContainer.current)
            inputRefContainer.current.style.width = '10px';
        setTimeout(() => {
            if (text.length)
                setText('');
            dispatch(setSearchMessages(false));
            dispatch(setTargetMessages([]));
        }, 400);
    };
    useEffect(() => {
        const delay = setTimeout(show, 100);
        return () => {
            setText('');
            dispatch(setTargetMessages([]));
            clearTimeout(delay);
        };
    }, []);
    useEffect(() => {
        if (debouncedText) {
            const result = searchMessagesInList(list, text);
            dispatch(setTargetMessages([...result]));
        }
        else {
            dispatch(setTargetMessages([]));
        }
    }, [debouncedText]);
    return (_jsx("div", { className: styles.inputNewMessage, children: _jsxs("div", { className: styles.searchMessages, children: [_jsx(InputComponent, { returnValue: setText, isCleanIcon: true, refInput: inputRef, refContainer: inputRefContainer, classes: styles.searchMessages_input }), _jsx("div", { className: styles.searchMessages_button, children: _jsx("button", { onClick: hide, children: t('cancel') }) })] }) }));
};
export default SearchMessages;
